export const DEFAULT_PADDING_AROUND_DONUT_CHART = 24;
export const DEFAULT_CHART_SIZE = 240;

const COMPACT_THRESHOLDS = [
  { value: 1_000_000, suffix: "M" },
  { value: 1_000, suffix: "k" },
] as const;

export const formatCompactNumber = (value: number | null): string => {
  if (value === null) {
    return "";
  }

  for (const { value: threshold, suffix } of COMPACT_THRESHOLDS) {
    if (Math.abs(value) >= threshold) {
      const compact = value / threshold;
      const formatted = compact % 1 === 0 ? compact.toFixed(0) : compact.toFixed(1);
      return `${formatted}${suffix}`;
    }
  }

  return value.toString();
};
